export enum CurrentTransaction {
  Approve,
  StakeUrus,
  Deposit,
}
